import React, { useState } from 'react';
import { BiDownArrow, BiMenu } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isAnotherDropdownOpen, setIsAnotherDropdownOpen] = useState(false);
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const toggleAnotherDropdown = () => {
        setIsAnotherDropdownOpen(!isAnotherDropdownOpen);
    };
    return (
        <nav className=" border-gray-200  border-b-2 text-sm ">
            <div className="max-w-screen-xl max-[760px]:flex flex-wrap items-center justify-between p-4 ">

                <Link to={"/"} className="flex items-center bg-white">
                    <img src="/logo.png" className="h-12 mr-2" alt="Devine school Logo" />
                    <div className="self-center text-2xl font-semibold  whitespace-nowrap text-gray-800 flex flex-col">
                        <h2 className='text-[16px] font-serif'>DIVINE ROYAL</h2>
                        <h2 className='text-[12px] font-serif text-[#f7951e]'>INTERNATIONAL COLLEGE</h2>
                    </div>
                </Link>

                <button
                    onClick={toggleMobileMenu}
                    type="button"
                    className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                    aria-controls="navbar-dropdown"
                    aria-expanded={isMobileMenuOpen}
                >
                    <span className="sr-only">Open main menu</span>
                    <BiMenu className='text-4xl' />
                </button>

                <div className={`w-full md:block md:w-auto ${isMobileMenuOpen ? 'block' : 'hidden'}`} id="navbar-dropdown">
                    <ul className="flex flex-col font-medium p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-white ">
                        <li>
                            <Link
                                to={'/'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 "
                            >
                                Home
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={'/about'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 "
                            >
                                About Us
                            </Link>
                        </li>

                        <li>
                            <button
                                onClick={toggleDropdown}
                                id="dropdownNavbarLink"
                                data-dropdown-toggle="dropdownNavbar"
                                className={`flex items-center space-x-2 justify-between w-full py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 md:w-auto dark:text-white md:dark:hover:text-blue-500 dark:focus:text-white dark:border-gray-700 ${isDropdownOpen ? 'md:dark:hover:bg-transparent' : 'dark:hover:bg-gray-700'}`}
                            >
                                <h1>Portal</h1>
                                <BiDownArrow />
                            </button>

                            <div className={`z-10 ${isDropdownOpen ? 'block md:fixed md:z-50' : 'hidden'} font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600`}>
                                <ul className="py-2 px-6  space-y-2 text-sm text-gray-700 " aria-labelledby="dropdownLargeButton">

                                    <li>
                                        <Link to={'/signin-admin'} className=" py-2 hover-bg-gray-100 ">Admin Portal</Link>
                                    </li>

                                    <li>
                                        <Link to={'/signin-teacher'} className=" py-2 hover-bg-gray-100 ">Teacher Portal</Link>
                                    </li>

                                    <li>
                                        <Link to={'/signin-student'} className=" py-2 hover-bg-gray-100 ">Student Portal</Link>
                                    </li>
                                </ul>

                            </div>
                        </li>




                        <li>
                            <button
                                onClick={toggleAnotherDropdown}
                                id="anotherDropdownNavbarLink"
                                data-dropdown-toggle="anotherDropdownNavbar"
                                className={`flex items-center space-x-2 justify-between w-full py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 md:w-auto dark:text-white md:dark:hover-text-blue-500 dark:focus:text-white dark:border-gray-700 ${isAnotherDropdownOpen ? 'md:dark:hover:bg-transparent' : 'dark:hover-bg-gray-700'}`}
                            >
                                <h1>Academics</h1>
                                <BiDownArrow />
                            </button>

                            <div className={`z-10 ${isAnotherDropdownOpen ? 'block md:fixed md:z-50' : 'hidden'} font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600`}>
                                <ul className="py-2 px-6 space-y-2 text-sm text-gray-700" aria-labelledby="anotherDropdownLargeButton">
                                    <li>
                                        <Link to={'/curriculum'} className="py-2 hover:bg-gray-100">Curriculum</Link>
                                    </li>
                                    <li>
                                        <Link to={'/another-link-2'} className="py-2 hover-bg-gray-100">Extra-curricular Activities</Link>
                                    </li>
                                </ul>
                            </div>
                        </li>




                        <li>
                            <Link
                                to={'/admission'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 dark:text-white md:dark:hover-text-blue-500 dark:hover-bg-gray-700 dark:hover-text-white md:dark:hover-bg-transparent"
                            >
                                Admissions
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={'/exam'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 dark:text-white md:dark:hover-text-blue-500 dark:hover-bg-gray-700 dark:hover-text-white md:dark:hover-bg-transparent"
                            >
                                Entrance Exam
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={'/signin-student'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 dark:text-white md:dark:hover-text-blue-500 dark:hover-bg-gray-700 dark:hover-text-white md:dark:hover-bg-transparent"
                            >
                                E-Learning
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={'/library'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 dark:text-white md:dark:hover-text-blue-500 dark:hover-bg-gray-700 dark:hover-text-white md:dark:hover-bg-transparent"
                            >
                                E-Library
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={'/gallery'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 dark:text-white md:dark:hover-text-blue-500 dark:hover-bg-gray-700 dark:hover-text-white md:dark:hover-bg-transparent"
                            >
                                Gallery
                            </Link>
                        </li>



                        <li>
                            <Link
                                to={'/news'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 dark:text-white md:dark:hover-text-blue-500 dark:hover-bg-gray-700 dark:hover-text-white md:dark:hover-bg-transparent"
                            >
                                News and Annoucmant
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={'/contact'}
                                className="block py-2 pl-3 pr-4 text-gray-900 rounded hover-bg-gray-100 md:hover-bg-transparent md:border-0 md:hover-text-blue-700 md:p-0 dark:text-white md:dark:hover-text-blue-500 dark:hover-bg-gray-700 dark:hover-text-white md:dark:hover-bg-transparent"
                            >
                                Contact Us
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

    );
};

export default Navbar;